import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';

// Le tableau de bord vit désormais sous `/c/:clientId/dashboard` (#173) : il est
// déclaré dans `app-routing.module.ts`, avec les autres écrans d'un dossier.
const routes: Routes = [
    { path: '', component: HomeComponent, title: 'Accueil', data: { screen: 'home.accueil-organisations' } },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})
export class HomeRoutingModule {}
